import React from 'react'
import { useNavigate } from 'react-router-dom'
import './BrightTomorrow.css'
import girlkids3 from '../../assets/mainimage2.png'
import rocketIcon from '../../assets/rocket.svg'
import curveShape from '../../assets/curve1.svg'

function BrightTomorrow() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div id="bright-tomorrow" className="bright-tomorrow bright-tomorrow-section">
      <div className="bright-tomorrow-container">
        {/* Decorative Elements */}
        <div className="decorative-plus plus-bottom-right-smaller">+</div>
        <div className="decorative-plus plus-bottom-right">+</div>

        {/* Main Content */}
        <div className="content-wrapper">
          {/* Left Side - Image */}
          <div className="image-section">
            <div className="circular-image-wrapper">
              <img src={girlkids3} alt="Happy students" className="main-image" />
            </div>
          </div>

          {/* Right Side - Text */}
          <div className="text-section">
            <img src={rocketIcon} alt="" aria-hidden="true" className="decorative-rocket" />
            <h2 className="bright-tomorrow-section-title">
              Nurturing Bright Minds for a Brighter Tomorrow
            </h2>
            <p className="bright-tomorrow-section-description">
            Creating pathways for lifelong learning, fostering growth, and opening doors to new opportunities for every student and teacher.
            </p>
            <button className="admission-btn" onClick={handleContactClick}>
              <span>Contact us</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12h12M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Feature Cards Strip */}
        <div className="features-strip" role="list">
          <div className="feature-card" role="listitem">
            <div className="feature-icon" aria-hidden="true">
              {/* Tablet / e-learning icon */}
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="4" width="18" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.8"/>
                <path d="M8 18h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                <circle cx="12" cy="11" r="2.5" stroke="currentColor" strokeWidth="1.6"/>
              </svg>
            </div>
            <div className="feature-text">
              <h3>Digital Learning Tools</h3>
              <p>Gamified platforms, assessments, and e-learning systems that make education both fun and effective.</p>
            </div>
          </div>

          <div className="feature-card" role="listitem">
            <div className="feature-icon" aria-hidden="true">
              {/* Lightbulb / innovation icon */}
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path d="M12 3a6.5 6.5 0 0 0-3.5 12.1V18a1.5 1.5 0 0 0 1.5 1.5h4A1.5 1.5 0 0 0 15.5 18v-2.9A6.5 6.5 0 0 0 12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10 21h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="feature-text">
              <h3>Innovation in Learning</h3>
              <p>Hands-on projects, STEM labs, and smart classes that inspire creativity and critical thinking.</p>
            </div>
          </div>

          <div className="feature-card" role="listitem">
            <div className="feature-icon" aria-hidden="true">
              {/* Shield / security icon */}
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path d="M12 3l7 3v6c0 5-4.5 7.5-7 9-2.5-1.5-7-4-7-9V6l7-3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                <path d="M9.5 12.5l1.8 1.8 3.7-3.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="feature-text">
              <h3>Safe & Smart Campus</h3>
              <p>Secure digital classrooms, access control, and safety protocols for peace of mind.</p>
            </div>
          </div>
        </div>

        {/* Bottom Curve */}
        {/* <img src={curveShape} alt="" className="bottom-curve" /> */}

        {/* Planet Icon (decorative) */}
        <svg className="planet-icon" viewBox="0 0 80 80" aria-hidden="true">
          {/* Planet body with gradient */}
          <defs>
            <radialGradient id="planetGradient" cx="50%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#4A90E2" />
              <stop offset="70%" stopColor="#0088FF" />
              <stop offset="100%" stopColor="#0066CC" />
            </radialGradient>
            <linearGradient id="ringGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(0,136,255,0.3)" />
              <stop offset="50%" stopColor="rgba(0,136,255,0.8)" />
              <stop offset="100%" stopColor="rgba(0,136,255,0.3)" />
            </linearGradient>
          </defs>
          
          {/* Planet body */}
          <circle cx="40" cy="40" r="18" fill="url(#planetGradient)" stroke="currentColor" strokeWidth="1.5"></circle>
          
          {/* Planet surface details */}
          <ellipse cx="35" cy="35" rx="8" ry="4" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1"></ellipse>
          <ellipse cx="45" cy="45" rx="6" ry="3" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1"></ellipse>
          
          {/* Outer ring */}
          <ellipse cx="40" cy="40" rx="28" ry="6" fill="none" stroke="url(#ringGradient)" strokeWidth="2"></ellipse>
          
          {/* Inner ring */}
          <ellipse cx="40" cy="40" rx="24" ry="4" fill="none" stroke="url(#ringGradient)" strokeWidth="1.5"></ellipse>
          
          {/* Ring particles */}
          <circle cx="12" cy="40" r="1" fill="rgba(0,136,255,0.6)"></circle>
          <circle cx="68" cy="40" r="1" fill="rgba(0,136,255,0.6)"></circle>
          <circle cx="40" cy="16" r="0.8" fill="rgba(0,136,255,0.4)"></circle>
          <circle cx="40" cy="64" r="0.8" fill="rgba(0,136,255,0.4)"></circle>
        </svg>
      </div>
    </div>
  )
}

export default BrightTomorrow
